import { useId, useRef } from "react";
import useFocusTrap from "../../utils/useFocusTrap";
import "../../styles/components/AdminModal.css";

export default function AdminModal({ open, title, onClose, children }) {
  const dialogRef = useRef(null);
  const titleId = useId();

  useFocusTrap(dialogRef, open, onClose);

  if (!open) return null;

  return (
    <div className="adminModalOverlay" role="presentation" onMouseDown={onClose}>
      <div
        className="adminModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={dialogRef}
        tabIndex={-1}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="adminModal__header">
          <h2 className="adminModal__title" id={titleId}>
            {title}
          </h2>
          <button className="adminModal__close" type="button" onClick={onClose} aria-label="Close">
            X
          </button>
        </div>
        <div className="adminModal__body">{children}</div>
      </div>
    </div>
  );
}
